(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["activity-page"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const form = document.getElementById('activity-product-form');
    const variantIdInput = document.getElementById('activity-selected-variant-id');
    const optionCards = document.querySelectorAll('[data-variant-option]');
    
    const modeWrap = document.getElementById('business-mode-wrap');
    const modeTabSame = document.getElementById('mode-tab-same');
    const modeTabDiff = document.getElementById('mode-tab-diff');
    const configPaneSame = document.getElementById('config-pane-same');
    const configPaneDiff = document.getElementById('config-pane-diff');

    const cardGroup3 = document.getElementById('card-config-group-3');

    const sameInputs = document.querySelectorAll('.same-input');
    const diffInputs = document.querySelectorAll('.diff-input');

    const stickyBar = document.getElementById('sticky-buy-bar');
    const stickyTitle = document.getElementById('sticky-variant-title');
    const stickyPrice = document.getElementById('sticky-variant-price');
    const stickyBtn = document.getElementById('sticky-add-btn');
    const mainSubmitBtn = document.getElementById('main-submit-btn');

    let currentCardCount = 1;
    let currentMode = 'same'; // 'same' or 'diff'

    // Helper: URL validation (permissive for share links, rejects plain text)
    const isValidUrl = (str) => {
      if (!str) return true;
      const val = str.trim();
      if (val.length < 4) return false;
      if (/^https?:\/\/.+\..+/i.test(val)) return true;
      if (/^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(\/.*)?$/i.test(val)) return true;
      return false;
    };

    // Update active vs inactive inputs
    const syncInputStates = () => {
      const propSame = document.getElementById('prop-config-same');

      if (currentCardCount === 1) {
        if (configPaneSame) configPaneSame.style.display = 'block';
        if (configPaneDiff) configPaneDiff.style.display = 'none';

        sameInputs.forEach(input => { input.disabled = false; });
        if (propSame) propSame.disabled = true;

        diffInputs.forEach(input => { input.disabled = true; });
      } else if (currentMode === 'same') {
        if (configPaneSame) configPaneSame.style.display = 'block';
        if (configPaneDiff) configPaneDiff.style.display = 'none';

        sameInputs.forEach(input => { input.disabled = false; });
        if (propSame) propSame.disabled = false;

        diffInputs.forEach(input => { input.disabled = true; });
      } else {
        if (configPaneSame) configPaneSame.style.display = 'none';
        if (configPaneDiff) configPaneDiff.style.display = 'block';

        sameInputs.forEach(input => { input.disabled = true; });

        document.querySelectorAll('#card-config-group-1 .diff-input, #card-config-group-2 .diff-input, #prop-config-diff').forEach(input => {
          input.disabled = false;
        });

        if (currentCardCount === 3) {
          if (cardGroup3) cardGroup3.style.display = 'block';
          document.querySelectorAll('#card-config-group-3 .diff-input').forEach(input => {
            input.disabled = false;
          });
        } else {
          if (cardGroup3) cardGroup3.style.display = 'none';
          document.querySelectorAll('#card-config-group-3 .diff-input').forEach(input => {
            input.disabled = true;
          });
        }
      }

      updateStickyBtnState();
    };

    // 1. Check if the CURRENT ACTIVE configuration is fully valid
    const isConfigComplete = () => {
      if (currentCardCount === 1 || currentMode === 'same') {
        const nameInput = document.getElementById('act-name');
        const cityInput = document.getElementById('act-city');
        const linkInput = document.getElementById('act-link');

        if (!nameInput || !nameInput.value.trim()) return false;
        if (!cityInput || !cityInput.value.trim()) return false;
        if (linkInput && linkInput.value.trim() && !isValidUrl(linkInput.value)) return false;
        return true;
      } else {
        const checkCard = (num) => {
          const nameInput = document.getElementById(`act-name-${num}`);
          const cityInput = document.getElementById(`act-city-${num}`);
          const linkInput = document.getElementById(`act-link-${num}`);

          if (!nameInput || !nameInput.value.trim()) return false;
          if (!cityInput || !cityInput.value.trim()) return false;
          if (linkInput && linkInput.value.trim() && !isValidUrl(linkInput.value)) return false;
          return true;
        };

        if (!checkCard(1) || !checkCard(2)) return false;
        if (currentCardCount === 3 && !checkCard(3)) return false;
        return true;
      }
    };

    // 2. Update sticky CTA button text and state live
    const updateStickyBtnState = () => {
      if (!stickyBtn) return;
      if (isConfigComplete()) {
        stickyBtn.textContent = 'Aggiungi →';
        stickyBtn.setAttribute('data-action', 'submit');
      } else {
        stickyBtn.textContent = 'Configura →';
        stickyBtn.setAttribute('data-action', 'configure');
      }
    };

    // 3. Variant selection logic
    optionCards.forEach((card) => {
      card.addEventListener('click', () => {
        if (card.classList.contains('is-disabled')) return;

        const variantId = card.getAttribute('data-variant-id');
        const cardCount = parseInt(card.getAttribute('data-card-count') || '1', 10);
        const variantTitle = card.getAttribute('data-variant-title');
        const variantPrice = card.getAttribute('data-variant-price');

        currentCardCount = cardCount;
        if (variantIdInput) variantIdInput.value = variantId;

        optionCards.forEach((c) => {
          c.classList.remove('is-selected');
          const radio = c.querySelector('input[type="radio"]');
          if (radio) radio.checked = false;
        });

        card.classList.add('is-selected');
        const activeRadio = card.querySelector('input[type="radio"]');
        if (activeRadio) activeRadio.checked = true;

        if (currentCardCount > 1) {
          if (modeWrap) modeWrap.style.display = 'block';
        } else {
          if (modeWrap) modeWrap.style.display = 'none';
          currentMode = 'same';
          if (modeTabSame) {
            modeTabSame.classList.add('is-active');
            modeTabSame.setAttribute('aria-checked', 'true');
          }
          if (modeTabDiff) {
            modeTabDiff.classList.remove('is-active');
            modeTabDiff.setAttribute('aria-checked', 'false');
          }
        }

        syncInputStates();

        if (stickyTitle) stickyTitle.textContent = variantTitle.toUpperCase();
        if (stickyPrice) stickyPrice.textContent = variantPrice;
      });
    });

    // 4. Business Mode Tabs (Same vs Different)
    modeTabSame?.addEventListener('click', () => {
      currentMode = 'same';
      modeTabSame.classList.add('is-active');
      modeTabSame.setAttribute('aria-checked', 'true');
      modeTabDiff?.classList.remove('is-active');
      modeTabDiff?.setAttribute('aria-checked', 'false');
      syncInputStates();
    });

    modeTabDiff?.addEventListener('click', () => {
      currentMode = 'diff';
      modeTabDiff.classList.add('is-active');
      modeTabDiff.setAttribute('aria-checked', 'true');
      modeTabSame?.classList.remove('is-active');
      modeTabSame?.setAttribute('aria-checked', 'false');
      syncInputStates();
    });

    // 5. Form Validation Helper (Used when submitting)
    const validateForm = () => {
      let isValid = true;
      let firstInvalid = null;

      const markInvalid = (input, errorEl) => {
        input.classList.add('is-invalid');
        if (errorEl) errorEl.hidden = false;
        if (!firstInvalid) firstInvalid = input;
        isValid = false;
      };

      const markValid = (input, errorEl) => {
        input.classList.remove('is-invalid');
        if (errorEl) errorEl.hidden = true;
      };

      if (currentCardCount === 1 || currentMode === 'same') {
        const nameInput = document.getElementById('act-name');
        const cityInput = document.getElementById('act-city');
        const linkInput = document.getElementById('act-link');
        const nameError = document.getElementById('name-error-msg');
        const cityError = document.getElementById('city-error-msg');
        const linkError = document.getElementById('link-error-msg');

        if (!nameInput.value.trim()) markInvalid(nameInput, nameError);
        else markValid(nameInput, nameError);

        if (!cityInput.value.trim()) markInvalid(cityInput, cityError);
        else markValid(cityInput, cityError);

        if (linkInput.value.trim() && !isValidUrl(linkInput.value)) {
          markInvalid(linkInput, linkError);
          const details = document.getElementById('act-link-details-same');
          if (details) details.open = true;
        } else {
          markValid(linkInput, linkError);
        }
      } else {
        const validateCardGroup = (num) => {
          const nameInput = document.getElementById(`act-name-${num}`);
          const cityInput = document.getElementById(`act-city-${num}`);
          const linkInput = document.getElementById(`act-link-${num}`);
          const nameError = document.getElementById(`name-${num}-error-msg`);
          const cityError = document.getElementById(`city-${num}-error-msg`);
          const linkError = document.getElementById(`link-${num}-error-msg`);

          if (!nameInput.value.trim()) markInvalid(nameInput, nameError);
          else markValid(nameInput, nameError);

          if (!cityInput.value.trim()) markInvalid(cityInput, cityError);
          else markValid(cityInput, cityError);

          if (linkInput.value.trim() && !isValidUrl(linkInput.value)) {
            markInvalid(linkInput, linkError);
            const parentDetails = linkInput.closest('details');
            if (parentDetails) parentDetails.open = true;
          } else {
            markValid(linkInput, linkError);
          }
        };

        validateCardGroup(1);
        validateCardGroup(2);
        if (currentCardCount === 3) {
          validateCardGroup(3);
        }
      }

      if (!isValid && firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstInvalid.focus();
      }

      return isValid;
    };

    // Live update on input/change: clear field error & update sticky button ready state
    document.querySelectorAll('.form-input').forEach(input => {
      const handleInput = () => {
        if (input.value.trim()) {
          input.classList.remove('is-invalid');
          const errorMsg = input.parentElement.querySelector('.field-error-msg');
          if (errorMsg) errorMsg.hidden = true;
        }
        updateStickyBtnState();
      };
      input.addEventListener('input', handleInput);
      input.addEventListener('change', handleInput);
    });

    // Form submit listener (capturing phase for reliable novalidate interception)
    form?.addEventListener('submit', (e) => {
      if (!validateForm()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return;
      }

      const temporarilyDisabled = [];
      document.querySelectorAll('input[name*="Link Google Business"]').forEach(input => {
        if (!input.disabled && !input.value.trim()) {
          input.disabled = true;
          temporarilyDisabled.push(input);
        }
      });

      setTimeout(() => {
        temporarilyDisabled.forEach(input => {
          input.disabled = false;
        });
      }, 50);
    }, true);

    // 6. Sticky CTA Click Logic
    stickyBtn?.addEventListener('click', () => {
      if (isConfigComplete()) {
        mainSubmitBtn?.click();
      } else {
        // Find FIRST incomplete or invalid active field and focus it WITHOUT error explosion
        let firstTarget = null;
        if (currentCardCount === 1 || currentMode === 'same') {
          const nameInput = document.getElementById('act-name');
          const cityInput = document.getElementById('act-city');
          const linkInput = document.getElementById('act-link');

          if (nameInput && !nameInput.value.trim()) firstTarget = nameInput;
          else if (cityInput && !cityInput.value.trim()) firstTarget = cityInput;
          else if (linkInput && linkInput.value.trim() && !isValidUrl(linkInput.value)) firstTarget = linkInput;
        } else {
          for (let i = 1; i <= currentCardCount; i++) {
            const nameInput = document.getElementById(`act-name-${i}`);
            const cityInput = document.getElementById(`act-city-${i}`);
            const linkInput = document.getElementById(`act-link-${i}`);

            if (nameInput && !nameInput.value.trim()) { firstTarget = nameInput; break; }
            if (cityInput && !cityInput.value.trim()) { firstTarget = cityInput; break; }
            if (linkInput && linkInput.value.trim() && !isValidUrl(linkInput.value)) { firstTarget = linkInput; break; }
          }
        }

        if (firstTarget) {
          const parentDetails = firstTarget.closest('details');
          if (parentDetails) parentDetails.open = true;
          firstTarget.scrollIntoView({ behavior: 'smooth', block: 'center' });
          firstTarget.focus();
        } else {
          const target = document.getElementById('acquista');
          target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    });

    // 7. Central Sticky Visibility Controller
    let isPastPrimaryCTA = false;
    let isFooterVisible = false;
    let isMobile = window.innerWidth < 768;
    const footer = document.querySelector('.site-footer');

    const updateStickyVisibility = () => {
      if (!stickyBar) return;
      if (isPastPrimaryCTA && !isFooterVisible && isMobile) {
        stickyBar.classList.add('is-visible');
      } else {
        stickyBar.classList.remove('is-visible');
      }
    };

    const updateScrollState = () => {
      if (!mainSubmitBtn) return;
      const ctaRect = mainSubmitBtn.getBoundingClientRect();
      isPastPrimaryCTA = ctaRect.bottom < 0;

      if (footer) {
        const footerRect = footer.getBoundingClientRect();
        isFooterVisible = footerRect.top < window.innerHeight;
      }

      updateStickyVisibility();
    };

    window.addEventListener('scroll', () => {
      requestAnimationFrame(updateScrollState);
    }, { passive: true });

    window.addEventListener('resize', () => {
      isMobile = window.innerWidth < 768;
      updateScrollState();
    });

    if (mainSubmitBtn && 'IntersectionObserver' in window) {
      const ctaObserver = new IntersectionObserver(() => {
        updateScrollState();
      }, { threshold: [0, 1] });
      ctaObserver.observe(mainSubmitBtn);
    }

    if (footer && 'IntersectionObserver' in window) {
      const footerObserver = new IntersectionObserver(() => {
        updateScrollState();
      }, { threshold: [0, 0.05, 0.1] });
      footerObserver.observe(footer);
    }

    updateScrollState();

    // 8. Smooth scroll for anchor buttons
    document.querySelectorAll('a[href="#acquista"]').forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        e.preventDefault();
        const target = document.getElementById('acquista');
        if (target) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });

    // 9. Accordion single-open behavior
    const faqCards = document.querySelectorAll('.activity-faq-section .faq-card');
    faqCards.forEach((card) => {
      card.addEventListener('toggle', () => {
        if (card.open) {
          faqCards.forEach((other) => {
            if (other !== card) other.removeAttribute('open');
          });
        }
      });
    });

    // Initialize initial variant and state
    const initialCard = document.querySelector('[data-variant-option].is-selected');
    if (initialCard) {
      currentCardCount = parseInt(initialCard.getAttribute('data-card-count') || '1', 10);
      if (currentCardCount > 1 && modeWrap) {
        modeWrap.style.display = 'block';
      }
    }
    syncInputStates();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["local-business-offer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.business-purchase');
    if (!section) return;
    const idInput = section.querySelector('[data-business-variant-id]');
    const price = section.querySelector('[data-business-price]');
    const choices = section.querySelectorAll('input[name="business_variant_choice"]');
    choices.forEach((choice) => {
      choice.addEventListener('change', () => {
        if (idInput) idInput.value = choice.value;
        if (price) price.textContent = choice.dataset.price;
        choices.forEach((item) => item.closest('.business-variant')?.classList.toggle('is-selected', item.checked));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reseller-offer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const section = document.querySelector('.reseller-purchase');
    if (!section) return;
    const idInput = section.querySelector('[data-reseller-variant-id]');
    const price = section.querySelector('[data-reseller-price]');
    const unit = section.querySelector('[data-reseller-unit]');
    const choices = section.querySelectorAll('input[name="reseller_variant_choice"]');
    choices.forEach((choice) => {
      choice.addEventListener('change', () => {
        if (idInput) idInput.value = choice.value;
        if (price) price.textContent = choice.dataset.price;
        if (unit) unit.textContent = choice.dataset.unit;
        choices.forEach((item) => item.closest('.reseller-variant')?.classList.toggle('is-selected', item.checked));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reseller-page"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const rail = document.querySelector('[data-packs-rail]');
    const dots = document.querySelectorAll('[data-dot-index]');
    const cards = document.querySelectorAll('[data-pack-card]');

    if (rail && dots.length > 0 && cards.length > 0) {
      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = parseInt(dot.getAttribute('data-dot-index'), 10);
          if (cards[index]) {
            cards[index].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
          }
        });
      });

      let scrollTimer = null;
      rail.addEventListener('scroll', () => {
        if (scrollTimer) clearTimeout(scrollTimer);
        scrollTimer = setTimeout(() => {
          const railCenter = rail.getBoundingClientRect().left + rail.offsetWidth / 2;
          let closestIndex = 0;
          let minDistance = Infinity;

          cards.forEach((card, idx) => {
            const cardRect = card.getBoundingClientRect();
            const cardCenter = cardRect.left + cardRect.width / 2;
            const distance = Math.abs(railCenter - cardCenter);
            if (distance < minDistance) {
              minDistance = distance;
              closestIndex = idx;
            }
          });

          dots.forEach((d, i) => {
            d.classList.toggle('is-active', i === closestIndex);
          });
        }, 60);
      }, { passive: true });

      if (window.innerWidth < 1024) {
        const growthCard = document.getElementById('pack-growth');
        const packSection = document.getElementById('scegli-il-tuo-pack');

        if (growthCard) {
          const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          const calculateTargetLeft = () => {
            const cardRect = growthCard.getBoundingClientRect();
            const railRect = rail.getBoundingClientRect();
            return (cardRect.left - railRect.left) + rail.scrollLeft - (rail.clientWidth - cardRect.width) / 2;
          };

          if (prefersReducedMotion) {
            const targetLeft = calculateTargetLeft();
            rail.scrollTo({ left: Math.max(0, targetLeft), behavior: 'auto' });
            dots.forEach((d, i) => d.classList.toggle('is-active', i === 2));
          } else {
            setTimeout(() => {
              const hasOtherHash = window.location.hash && window.location.hash !== '#scegli-il-tuo-pack';
              if (!hasOtherHash && window.scrollY < 80 && packSection) {
                packSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
              }
              const targetLeft = calculateTargetLeft();
              rail.scrollTo({ left: Math.max(0, targetLeft), behavior: 'smooth' });
              dots.forEach((d, i) => d.classList.toggle('is-active', i === 2));
            }, 350);
          }
        }
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
